import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./HeroSection.module.css";
import image from "../../assets/TOWER.jpg";
const HeroSection = () => {
  const navigate = useNavigate();

  const handleProjectsClick = () => {
    navigate('/?page=/gallery');
  };

  const handleContactClick = () => {
    navigate('/?page=/contact');
  };

  return (
    <section className={styles.hero}>
      <div className={styles.overlay}></div>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            <span className={styles.highlight}>THRONE</span> STONE
          </h1>
          <h2 className={styles.subtitle}>Crafting Timeless Stone Structures</h2>
          <div className={styles.divider}></div>
          <p className={styles.description}>
            We specialize in integrating premium local and imported natural stones 
            into modern and classic construction projects, creating lasting beauty 
            that stands the test of time.
          </p>
          <div className={styles.buttons}>
            <button className={styles.primaryBtn} onClick={handleProjectsClick}>
              Our Projects
            </button>
            <button className={styles.secondaryBtn} onClick={handleContactClick}>
              Contact Us
            </button>
          </div>
        </div>
        <div className={styles.imageContainer}>
          <div className={styles.imageWrapper}>
            <img src={image} alt="Stone Tower Project" className={styles.towerImage} />
            <div className={styles.imageBadge}>
              <span>Featured Project</span>
              <strong>The Clock Tower - Nuwara Eliya</strong>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.decorativeCorner1}></div>
      <div className={styles.decorativeCorner2}></div>
    </section>
  );
};

export default HeroSection;